"use client";
import { FC } from "react";
import { ButtonProps } from "./ButtonProps";
import { AddFolder, FlimIcon } from "assets";
import { CustomTooltip } from "components";

const AddFolderButton: FC<ButtonProps> = ({
  children,
  type,
  className,
  onClick,
  label,
  tooltip,
  disabled,
  onVideo,
}) => {
  return (
    <>
      <CustomTooltip title={tooltip} placement="bottom">
        <button
          disabled={disabled}
          title={label}
          onClick={onClick}
          type={type}
          className={`${
            disabled
              ? "bg-primary-400"
              : "bg-primary-500 hover:bg-primary-900 hover:shadow-lg"
          } text-white font-semibold px-4 py-2 rounded-lg shadow-md  duration-300 ease-in-out transform ${className}`}
        >
          <span className="flex items-center space-x-2 justify-center text-xs font-semibold">
            <div className="flex items-center gap-1">
              {onVideo ? <FlimIcon/> :<AddFolder />}
              {label} {children || ""}
            </div>
          </span>
        </button>
      </CustomTooltip>
    </>
  );
};

export default AddFolderButton;
